module.exports = __webpack_public_path__ + "static/img/4.3842c1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/4.png
// module id = VeOp
// module chunks = 94